import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SystemStatusListDto } from 'swagger';

@Component({
    selector: 'app-systemstatustooltip',
    templateUrl: './systemstatustooltip.component.html',
    styleUrls: ['./systemstatustooltip.component.scss'],
    standalone: false
})
export class SystemstatustooltipComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SystemStatusListDto
  ) { }
}
